import { AuthApi } from '@quadminds/client-apis/auth';
import { AUTH_API_URL, PLATFORM_URL, STORK_AUTH_API_URL } from '../../config';

// OMS pega auth cross-origin al auth-service SaaS (baseURL); el resto same-origin.
// El gate se calcula desde PLATFORM_URL (config), NO importando isOms de utils:
// utils ↔ services/api es un ciclo → importar isOms acá da TDZ ("Cannot access
// 'isOms' before initialization") y rompe TODAS las landings (Mindy/Stork/OMS).
const isOmsPlatform = !!PLATFORM_URL?.includes('tms');
const authApiOpts = isOmsPlatform ? { baseURL: AUTH_API_URL } : {};
export const authApi = new AuthApi({ ...authApiOpts, withCredentials: true });
export const storkAuthApi = new AuthApi({ baseURL: STORK_AUTH_API_URL, withCredentials: true });
